export default __webpack_public_path__ + "static/media/1.1bc44ab8.png";